import { render, staticRenderFns } from "./AnnouncementEdit.vue?vue&type=template&id=1f7a4eda"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=js"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementEdit.vue?vue&type=style&index=0&id=1f7a4eda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports